import React from 'react';

import Button from '../../../components/ui/Button';

const FormActions = ({ onSave, onCancel, isSaving, hasActiveTrip, isValid }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
      <Button
        variant="outline"
        size="lg"
        onClick={onCancel}
        disabled={isSaving}
        iconName="X"
        iconPosition="left"
        className="w-full sm:w-auto"
      >
        Cancel
      </Button>
      <Button
        variant="default"
        size="lg"
        onClick={onSave}
        loading={isSaving}
        disabled={!isValid || isSaving}
        iconName="public/assets/images/B42A68D7-7405-4964-872F-D36C4B1CBA1C-1768359280145.jpg"
        iconPosition="left"
        className="w-full sm:flex-1"
      >
        {isSaving ? 'Creating Trip...' : 'Create Trip & Start Planning'}
      </Button>
    </div>
  );
};

export default FormActions;